import dayjs, { Dayjs } from 'dayjs';
import { TimeRange } from './types';
import { MAX_DATE_SPAN_DAYS } from './constants';

// 获取默认时间范围
export const getDefaultDateRange = (): [Dayjs, Dayjs] => {
  const now = dayjs();
  if (now.date() === 1) {
    // 1 号默认选择上个月
    return [now.subtract(1, 'month').startOf('month'), now.subtract(1, 'month').endOf('month')] as [Dayjs, Dayjs];
  }
  // 默认结束时间不包含当天
  return [now.startOf('month'), now.subtract(1, 'day').endOf('day')] as [Dayjs, Dayjs];
};

// 验证时间范围跨度不超过 31 天
export const validateDateRange = (start: Dayjs | null, end: Dayjs | null): boolean => {
  if (!start || !end) return false;
  const days = end.diff(start, 'day');
  return days <= MAX_DATE_SPAN_DAYS && days >= 0;
};

// 验证查询时段是否重复
export const validateTimeRangeDuplicate = (newRange: TimeRange, existingRanges?: TimeRange[]): boolean => {
  return !existingRanges?.some(
    range =>
      (newRange.monitorStartTime >= range.monitorStartTime && newRange.monitorStartTime < range.monitorEndTime) ||
      (newRange.monitorEndTime > range.monitorStartTime && newRange.monitorEndTime <= range.monitorEndTime) ||
      (newRange.monitorStartTime <= range.monitorStartTime && newRange.monitorEndTime >= range.monitorEndTime)
  );
};

// 将 Dayjs 转换为时间戳
export const dayjsToTimestamp = (date: Dayjs): number => {
  return date.valueOf();
};
